import { graphql } from '../graphql/generated';

export const OPEN_REQUESTS_COUNT_QUERY = graphql(`
  query OpenRequestsCount($doctorId: ID!) {
    openRequestsCount(doctorId: $doctorId)
  }
`);
